import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgBulb = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-bulb';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.354 2.284c-2.66.205-5.107 1.921-6.265 4.394a7.94 7.94 0 0 0-.567 4.956c.268 1.295.901 2.538 1.828 3.59l.279.316.129.6c.185.864.343 1.485.531 2.09l.164.53h9.14l.082-.35c.303-1.3.615-2.577.666-2.73.037-.111.161-.294.326-.479.985-1.107 1.593-2.368 1.88-3.901.083-.441.115-1.67.057-2.164-.358-3.041-2.372-5.543-5.224-6.492a7.1 7.1 0 0 0-1.82-.363c-.589-.045-.587-.045-1.206.003m1.866 1.597c.558.118.923.246 1.48.521 1.783.882 3.034 2.589 3.362 4.59.118.72.072 1.858-.102 2.534-.273 1.06-.723 1.882-1.552 2.832-.374.428-.477.691-.788 2.002l-.204.86-3.424.01c-3.208.01-3.425.006-3.45-.058a27 27 0 0 1-.225-.951c-.299-1.328-.344-1.441-.755-1.901-.903-1.012-1.42-2.065-1.624-3.312-.084-.512-.084-1.504 0-2.016a6.23 6.23 0 0 1 1.77-3.448A6.1 6.1 0 0 1 11.24 3.8c.436-.06 1.525-.015 1.98.081M12 6.489c0 .838-.021.789.341.79.405.002 1.031.263 1.431.597.536.448.947 1.219.949 1.783.001.362-.048.341.79.341h.741l-.024-.35a4.12 4.12 0 0 0-1.206-2.656 4.25 4.25 0 0 0-2.672-1.221L12 5.748zM8 21v.76h8v-1.52H8z"
    })
  }));
});
export default SvgBulb;